import React, { PropTypes } from 'react';
import L10n from './L10n';

const MenuItem = ({ item, lang, onClick, className }) => (
  <li className={className} onClick={onClick}>
    <L10n lang={lang} item={item.get('title')} />
  </li>
);

MenuItem.propTypes = {
  item: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./common/components/MenuItem.js